import { render, staticRenderFns } from "./customerAcountDetail.vue?vue&type=template&id=2621d9a3&scoped=true&"
import script from "./customerAcountDetail.vue?vue&type=script&lang=js&"
export * from "./customerAcountDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerAcountDetail.vue?vue&type=style&index=0&id=2621d9a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621d9a3",
  null
  
)

export default component.exports